import { render, staticRenderFns } from "./versionFilmRecordByShowTime.vue?vue&type=template&id=da2b7674&scoped=true&"
import script from "./versionFilmRecordByShowTime.vue?vue&type=script&lang=js&"
export * from "./versionFilmRecordByShowTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2b7674",
  null
  
)

export default component.exports